import { Button, Form, Input, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import contactAdminService from '../../../services/adminService/ContactAdminService';

const ConfirmStatusModal = ({ selectRecord, refetch, handleCancel }) => {
    const [form] = useForm()
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (selectRecord?.status === 1) {
            form.setFieldsValue({
                status: 2,
            });
        } else if (selectRecord?.status === 2) {
            form.setFieldsValue({
                status: 2,
            });
            form.setFieldsValue({
                reply: selectRecord?.reply,
            });
        } else if (selectRecord?.status === 3) {
            form.setFieldsValue({
                status: 3,
            });
        }

    }, [selectRecord, handleCancel]);

    const handleOk = (values) => {
        setLoading(true)
        const formData = new FormData();
        formData.append("status", values?.status);
        formData.append("reply", values?.reply);

        const data = contactAdminService.updatedContact(selectRecord?.id, formData);

        data.then((res) => {
            if (res?.status === 200) {
                toast.success(res?.message);
                form.resetFields();
                handleCancel()
                refetch();
            } else {
                toast.warn(res?.message);
            }
            setLoading(false)
        }).catch((err) => {
            toast.error(err);
            setLoading(false)
        });
    };
    const handleModalCancel = () => {
        form.resetFields();
        handleCancel();
    };

    return (
        <>
            <Form
                name="status"
                onFinish={handleOk}
                autoComplete="off"
                layout='vertical'
                form={form}

            >
                <Form.Item
                    label="Trạng thái"
                    name="status"
                >

                    <Select
                        options={[

                            {
                                value: 2,
                                label: "Đã tiếp nhận",
                            },
                            {
                                value: 3,
                                label: "Đã xử lý",
                            },
                        ]}
                    />
                </Form.Item>
                <Form.Item
                    label="Nội dung"
                    name="reply"
                    rules={[
                        {
                            required: true,
                            message: "Vui lòng nhập nội dung!",
                        },
                    ]}
                >
                    <Input.TextArea rows={4} placeholder="Nhập nội dung trạng thái" />

                </Form.Item>
                <Form.Item className='d-flex justify-content-end'>
                    <Button type="default" onClick={handleModalCancel}>
                        Hủy
                    </Button>
                    <Button type="primary" htmlType="submit" className='ms-2' loading={loading}>
                        Cập nhật
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}

export default ConfirmStatusModal